export const socialMediaList = ['https://facebook.com', 'https://instagram.com', 'https://tiktok.com'];

export const invalidWebsiteList = [
  'https://testing.com',
  'https://test.com',
  'https://expedia.com',
  'https://hotels.com',
  'https://vrbo.com',
];
